import { useEffect, useRef } from "react";

/**
 * Master v5 Prompt 10 — the in-app TidyCal embed widget. Mirrors
 * pages/Booking.jsx's own proven embed pattern (same CDN script src)
 * exactly, parameterized with the backend's own embed config
 * (data_path/data_name/data_email) so a Session booking always uses the
 * Workspace's correct SchedulingPolicy booking type and prefills the
 * signed-in member's own name/email — never a client-guessed value.
 */
export function TidyCalEmbed({ embed }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!embed?.script_src) return;
    const existing = document.querySelector(`script[src="${embed.script_src}"]`);
    if (existing) {
      if (window.TidyCal?.init) window.TidyCal.init(containerRef.current || undefined);
      return;
    }
    const s = document.createElement("script");
    s.src = embed.script_src;
    s.async = true;
    document.body.appendChild(s);
  }, [embed?.script_src, embed?.data_path]);

  if (!embed?.data_path) return null;

  return (
    <div data-testid="session-tidycal-embed" className="w-full">
      <div
        ref={containerRef}
        className="tidycal-embed w-full min-h-[640px] bg-paper rounded-xl border border-ink/10 p-4"
        data-path={embed.data_path}
        data-name={embed.data_name || undefined}
        data-email={embed.data_email || undefined}
      />
    </div>
  );
}
